import React, { useState } from 'react'

import styles from './HeroVideo.module.css'

const HeroVideo = ({ src, height, width }) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className={styles.container} style={{ height, width }}>
      <div className={`${styles.skeleton} ${loaded ? styles.hidden : ''}`} />
      <video
        className={`${styles.video} ${loaded ? '' : styles.hidden}`}
        src={src}
        height={height}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        onLoadedData={() => setLoaded(true)}
      />
    </div>
  )
}

export default HeroVideo
